import { ff } from '@atlassian/jira-feature-flagging';

// magma
export const isEcClientEventListenerEnabled = () => ff('odin.ec.client.integration');
